import React, { useMemo } from 'react';
import MuiIcon from 'e100-react-components/lib/components/Icon';
import { IPropTypes } from 'e100-react-components/lib/components/Icon/index';

import classNames from 'classnames';

import { getSvgIcon } from './svgIcons';

import { useStyles } from './styles';

export interface Props extends Omit<IPropTypes, 'kind'> {
  kind?: string;
}

export interface IconProps extends Props {}


export const Icon = (props: Props) => {
  const { kind, color, classes, style } = props;
  const SvgIcon = useMemo(() => getSvgIcon(kind), [kind]);
  const innerClasses = useStyles();
  if (!kind) return null;
  return (SvgIcon
    ? <SvgIcon
        color={color}
        classes={{
          ...classes,
          root: classNames({
            [classes?.root || '']: true,
            [innerClasses.root]: true
          })
        }}
        htmlColor={style?.color || ''}
      />
    : <MuiIcon {...props} kind={kind as IPropTypes['kind']} />
  );
};

export default Icon;
